// What booking says about the chosen address (records.forLocation; book/use-book-form.ts's
// useAddressNotes): its pinned alerts, then each piece of equipment under a warranty in force ("Under
// warranty until Mar 2027: the water heater, installed by …"), the same check jobs.book makes. Neither
// stops the booking.

import { useAddressNotes } from '../book/use-book-form.ts';
import './records.css';

export function BookingNotes({ locationId }: { locationId: string | null }) {
  const { alerts, warranties } = useAddressNotes(locationId);
  if (!alerts.length && !warranties.length) return null;
  return (
    <div className="book-notes" aria-label="About this address">
      {alerts.map((a) => (
        <p key={a.id} className="notice warn small">
          <b>Alert:</b> {a.body}
        </p>
      ))}
      {warranties.map((w) => (
        <p key={w} className="notice ok small">
          {w}
        </p>
      ))}
    </div>
  );
}
